import { createContext } from 'react';

export const ModalContext = createContext<{ closeModal: () => Promise<unknown> }>({
  closeModal: () => Promise.resolve(),
});
